import React from 'react';
import LayoutUsuario from '../../components/navegacao/LayoutUsuario';
import { ConteudoFaturas } from './ConteudoFaturas';

const FaturaPage = () => {
  return (
    <LayoutUsuario>
      <ConteudoFaturas />
    </LayoutUsuario>
  );
};

export default FaturaPage;
